<template>
  <div v-show="viewShow" class="link">
    <div class="main_view">
      <div v-if="linkType == 1">
        <p class="t1-title">{{title}}</p>
        <p class="t1-desc">{{desc}}</p>
        <div class="footer">
          <div @click="onRefuseClicked" class="refuse">
            <span>{{cancelBtn}}</span>
          </div>
          <div @click="onAcceptClicked" class="accept">
            <span>{{sureBtn}}</span>
          </div>
        </div>
      </div>
      <div v-if="linkType == 2">
        <p class="t2-desc">{{desc}}</p>
        <div class="footer t2-footer">
          <div class="t2-refuse" @click="onRefuseClicked">
            <img
              src="https://tengfaceliveuser.tengface.net/web/wx-user/img/refuse_lianmai.png"
            />
          </div>
          <div class="t2-accept" @click="onAcceptClicked">
            <img
              src="https://tengfaceliveuser.tengface.net/web/wx-user/img/accpet_lianmai.png"
            />
          </div>
        </div>
      </div>
      <div v-if="linkType == 3">
        <p class="t1-title">{{title}}</p>
        <div class="footer">
          <div @click="onRefuseClicked" class="refuse">
            <span>{{cancelBtn}}</span>
          </div>
          <div @click="onAcceptClicked" class="accept">
            <span>{{sureBtn}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    linkType: {
      type: Number,
      default: 1, //1 申请连麦  2老师邀请连麦  3取消连麦
    },
  },
  watch: {
    isShow(to) {
      this.viewShow = to;
    },
    linkType(to) {
      if (to === 1) {
        this.title = "申请连麦";
        this.desc = "是否申请与主播连麦？";
        this.sureBtn = "申请连麦";
        this.cancelBtn = "取消";
      } else if (to === 2) {
        this.title = "邀请连麦";
        this.desc = "老师 申请与您连麦…";
        this.sureBtn = "同意连麦";
        this.cancelBtn = "拒绝连麦";
      } else if (to === 3) {
        this.title = "你确认下麦吗？";
        this.sureBtn = "确认";
        this.cancelBtn = "取消";
      }
    },
  },
  data() {
    return {
      title: "申请连麦",
      desc: "是否申请与主播连麦？",
      sureBtn: "申请连麦",
      cancelBtn: "取消",
      viewShow: false,
    };
  },
  methods: {
    onAcceptClicked() {
      this.$emit("accept");
    },
    onRefuseClicked() {
      this.$emit("refuse");
    },
  },
};
</script>

<style lang="less">
.link {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4000;
  .main_view {
    border-radius: 20px;
    text-align: center;
    width: 80%;
    background-color: white;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 10px;
    p {
      margin-top: 20px;
    }
    .t1-title {
      margin-top: 10px;
      font-size: 20px;
    }
    .t1-desc {
      font-size: 18px;
    }
    .accept {
      margin-right: 20px;
      width: 33%;
      height: 46px;
      display: inline-block;
      border: solid 1px #008cf8;
      border-radius: 24px;
      background-color: #008cf8;
      span {
        line-height: 46px;
        color: white;
      }
    }

    .refuse {
      width: 33%;
      height: 46px;
      display: inline-block;
      border: solid 1px #008cf8;
      border-radius: 24px;
      background-color: white;
      margin-right: 10%;
      span {
        line-height: 46px;
        color: #008cf8;
      }
    }

    .footer {
      margin-top: 20px;
      margin-bottom: 10px;
      text-align: center;
    }

    .t2-refuse {
      display: inline-block;
      width: 25%;
      margin-right: 18%;
    }

    .t2-accept {
      display: inline-block;
      width: 25%;
    }

    .t2-desc {
      font-size: 20px;
      margin-top: 30px;
      margin-bottom: 40px;
    }
    .t2-footer {
      margin-bottom: 30px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// LinkPopup.vue?247395a0